export const Producers: { [key: string]: number[] } = {
  Bahia : [7790905, 10381433, 11282315],
  Botafogo : [6781843, 9231081, 8772447, 10279023, 3518768, 13682192],
  Dunas : [10708177, 11282553]
};

export const Biometry: { [key: string]: number[] } = {
  Imply : [...Producers.Bahia, ...Producers.Dunas]
};

type ProducerType = typeof Producers;

export type { ProducerType };
